export const environment = {
  production: true,
  connection: {
    name: 'LH Freistadt Softline TEST',
    host: 'https://softline-test.freistadt.rlh.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
